import { render, staticRenderFns } from "./ItemTypes.vue?vue&type=template&id=2381652f&scoped=true&"
import script from "./ItemTypes.vue?vue&type=script&lang=js&"
export * from "./ItemTypes.vue?vue&type=script&lang=js&"
import style0 from "./ItemTypes.vue?vue&type=style&index=0&id=2381652f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2381652f",
  null
  
)

export default component.exports